import { useNavigate } from 'react-router-dom'
import { useQueryClient } from 'react-query'
import routes from '../constants/routes'
import { useDataProvider } from '../context/DataProviderCtx/DataProvider'

const useLogout = () => {
  const { setIsEnabled } = useDataProvider()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const logout = () => {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
    localStorage.removeItem('mapPins')
    localStorage.removeItem('mapPinsAddedTime')
    queryClient.clear()
    navigate(routes.login)
    setIsEnabled(false)
  }

  return { logout }
}

export default useLogout
